/** @format */

export const INITIAL_STATE = {
  availabilityArray: [],
};
